import SearchIcon from '@mui/icons-material/Search'
import { LoadingButton } from '@mui/lab'
import { Box, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PostDialog from '../../SpiderWebSite/components/PostDialog'
import Title from '../../SpiderWebSite/components/Title'
import { IReduxState } from '../../store'
import { ISouscripteur, setFilteredSouscripteur, setListeEtabsSouscrit, setSouscripteur } from '../../store/focusEcoleSlice'
import { ADMIN_SERVER_BASE_URL, apiClient } from '../../util/apiClient'
import { anneescolaire } from '../../util/constant'
import { Add, IListeTuteur } from './Add'
import Liste from './Liste'
import SearchBar from './SearchBar'
import SearchBarByEtab from './SearchBarByEtab'
import SearchYear from './SearchYear'
import Statistique from './Statistique'
// import SearchBarByEtab from '../Enseignant/SearchBarByEtab'
// import * as XLSX from "xlsx";


export interface IPayloadCreateCompteParentalEtab {
    codeEtab: string;
    anneeScolaire: string;
    numerosTuteurs: string[];
}

const initialState: IPayloadCreateCompteParentalEtab = {
    codeEtab: "",
    anneeScolaire: "",
    numerosTuteurs: []
}


export default function CreationCompteParental(props:any) {

// Props
const {setLocalDatasFiltered, localDatasFiltered} = props


    const dispatch = useDispatch();
    const souscripteurs = useSelector((state: IReduxState) => state.focusEcole.souscripteurs);

    const [currentEtab, setCurrentEtab] = useState<any>({})
    const [open, setOpen] = useState(false)
    const [state, setState] = useState<IPayloadCreateCompteParentalEtab>(initialState)
    const [addLoading, setAddLoading] = useState(false)
    const [localArraySouscripteur, setLocalArraySouscripteur] = useState<ISouscripteur[]>([])
    const [search, setSearch] = React.useState("");
    const [currentYear, setCurrentYear] = useState<any>({})
    const [loadingGetTuteur, setLoadingGetTuteur] = useState(false)
    const [numerosTuteurs, setNumerosTuteurs] = useState<any>([]);
    const [optionSelected, setOptionSelected] = React.useState("excel");
    const [listeTuteurs, setListeTuteurs] = useState<IListeTuteur[]>([])
    const [loadingGetTuteurNonSouscrit, setLoadingGetTuteurSouscrit] = useState(false)


    const handleClose = () => {
        setOpen(false);
        setNumerosTuteurs([])
        setListeTuteurs([])
        setState(initialState)
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const filterFunction = () => {
        if (search.length === 0) {
            dispatch(setFilteredSouscripteur([...souscripteurs]));
        } else {
            const result: any = souscripteurs?.filter(
                (item: ISouscripteur, index: number) => {
                    const value: any = `${item?.numeroCellulaire} ${item?.nomPrenomParent} ${item?.codeEtab}`;
                    return value.toLowerCase().includes(search.toLowerCase());
                }
            );
            dispatch(setFilteredSouscripteur(result));
        }
    };

    React.useEffect(() => {
        filterFunction();
    }, [search]);

    const handleSave = async (e: any) => {
        e.preventDefault()
        try {
            setAddLoading(true)
            const apiPayload = {
                ...state,
                numerosTuteurs
            }
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/createcompteparentalbyadmin", apiPayload)
            if (res.status === 1) {
                dispatch(setSouscripteur(res.data))
                dispatch(setFilteredSouscripteur(res.data));
                handleClose()
            } else {
                console.log("status !==1")
            }
        } catch (error) {
            console.log("🚀 ~ file: index.tsx:49 ~ handleSave ~ error:", error)
        } finally {
            setAddLoading(false)
        }
    }

    const handleGetTuteurs = async () => {
        try {
            setLoadingGetTuteur(true)
            const apiPayload = {
                codeEtab: currentEtab.codeEtab,
                anneeScolaire: currentYear.anneescolaire
            }
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/getSouscripteurs", apiPayload);
            if (res.status === 1) {
                dispatch(setSouscripteur(res.data))
                dispatch(setFilteredSouscripteur(res.data))
            } else {
                console.log("getTuteurs status !==1");
            }
        } catch (error) {
            console.log("🚀 ~ file: index.tsx:45 ~ getTuteurs ~ error:", error)
        } finally {
            setLoadingGetTuteur(false)
        }
    };


    const getStudentsTuteursNonSouscrit = async () => {
        try {
            setLoadingGetTuteurSouscrit(true)
            const apiPayload = {
                codeEtab: state.codeEtab,
                anneeScolaire: state.anneeScolaire
            }
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/getStudentsTuteursNonSouscrit", apiPayload);
            if (res.status === 1) {
                setListeTuteurs(res.data)
            } else {
                console.log("setListeTuteurs status !==1");
            }
        } catch (error) {
            console.log("🚀 ~ file: index.tsx:45 ~ setListeTuteurs ~ error:", error)
        } finally {
            setLoadingGetTuteurSouscrit(false)
        }
    };


    useEffect(() => {
        if (state.codeEtab && state.anneeScolaire && listeTuteurs.length === 0)
            getStudentsTuteursNonSouscrit()
    }, [optionSelected === "select"])



    const getListeEtabsSouscrit = async () => {
        try {
            const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, `/tablesystem/getetabfocusecole/${anneescolaire}`);
            if (res.status === 1) {
                dispatch(setListeEtabsSouscrit(res.data))
            } else {
                console.log("else getListeEtabsSouscrit")
            }
        } catch (error) {
            console.log("🚀 ~ getListeEtabsSouscrit ~ error:", error)
        }
    };

    useEffect(() => {
        getListeEtabsSouscrit()
    }, [])



    // const handleFileUpload = (event: any) => {
    //     const file = event.target.files[0];
    //     const reader = new FileReader();

    //     reader.onload = (e: any) => {
    //         const data = new Uint8Array(e.target.result);
    //         const workbook = XLSX.read(data, { type: "array" });

    //         // Sélectionner la première feuille
    //         const sheetName = workbook.SheetNames[0];
    //         const worksheet = workbook.Sheets[sheetName];

    //         // Convertir la feuille en JSON
    //         const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    //         console.log(JSON.stringify(jsonData))

    //         const telTuteurs = jsonData.slice(2).map((row: any) => row[10]);
    //         //Filtrer les valeurs vides
    //         // const numerosTuteursNonNull = telTuteurs.filter((tuteur: any) => tuteur);
    //         const numerosTuteursNonNull = telTuteurs
    //             .filter((tuteur: any) => tuteur && !isNaN(Number(tuteur))) // filtre les tuteurs non nuls et non NaN
    //             .map((tuteur: any) => String(tuteur).split('.')[0]); // enlève le ".0"
    //         setNumerosTuteurs(numerosTuteursNonNull)
    //     };
    //     reader.readAsArrayBuffer(file);
    // };



    // const handleClick = (event: React.MouseEvent<unknown>, id: string) => {
    //     const selectedIndex = numerosTuteurs.indexOf(id);
    //     let newSelected: readonly string[] = [];

    //     if (selectedIndex === -1) {
    //         newSelected = newSelected.concat(numerosTuteurs, id);
    //     } else if (selectedIndex === 0) {
    //         newSelected = newSelected.concat(numerosTuteurs.slice(1));
    //     } else if (selectedIndex === numerosTuteurs.length - 1) {
    //         newSelected = newSelected.concat(numerosTuteurs.slice(0, -1));
    //     } else if (selectedIndex > 0) {
    //         newSelected = newSelected.concat(
    //             numerosTuteurs.slice(0, selectedIndex),
    //             numerosTuteurs.slice(selectedIndex + 1),
    //         );
    //     }
    //     setNumerosTuteurs(newSelected);
    // };

    const handleClick = (value: any) => () => {
        const currentIndex = numerosTuteurs.indexOf(value);
        const newChecked = [...numerosTuteurs];
        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        setNumerosTuteurs(newChecked);
    };

    return (
        <Box>
            <Grid container spacing={2} style={{ background: "#F7F7F7" }}>
                <Grid item xs={12} md={12} sm={12} lg={12}><Title intitule='Liste' /></Grid>
                <Grid item xs={12} md={3} sm={3} lg={3}>
                    {/* ancien recherche */}
                    <SearchBarByEtab
                        localArraySouscripteur={localArraySouscripteur}
                        setLocalArraySouscripteur={setLocalArraySouscripteur}
                        currentEtab={currentEtab}
                        setCurrentEtab={setCurrentEtab}
                    />

                </Grid>

                <Grid item xs={12} md={2} sm={2} lg={2}>
                    <SearchYear
                        localArraySouscripteur={localArraySouscripteur}
                        setLocalArraySouscripteur={setLocalArraySouscripteur}
                        currentYear={currentYear}
                        setCurrentYear={setCurrentYear}
                    />
                </Grid>

                <Grid item xs={12} md={2} sm={2} lg={2}>
                    <SearchBar
                        setSearch={setSearch}
                    />
                </Grid>

                <Grid item xs={12} md={1} sm={1} lg={1}>
                    <LoadingButton
                        loadingPosition="center"
                        loading={loadingGetTuteur}
                        endIcon={<SearchIcon />}
                        size="large"
                        variant="contained"
                        onClick={handleGetTuteurs}
                    >

                    </LoadingButton>
                </Grid>

                <Grid item xs={12} md={3} sm={3} lg={3}>
                    <Statistique
                        localArraySouscripteur={localArraySouscripteur}
                    />
                </Grid>

                <Grid item xs={12} md={1} sm={1} lg={1}>
                    <PostDialog
                        onClose={handleClose}
                        open={open}
                        handleOpenDialog={handleOpen}
                        title="Création de compte"
                        dialogContent={<Add
                            state={state}
                            setState={setState}
                            setNumerosTuteurs={setNumerosTuteurs}
                            numerosTuteurs={numerosTuteurs}
                            optionSelected={optionSelected}
                            setOptionSelected={setOptionSelected}
                            listeTuteurs={listeTuteurs}
                            handleClick={handleClick}
                        />}

                        actionFunc={handleSave}
                        addLoading={addLoading}
                    />

                </Grid>
            </Grid>
            <Liste />
        </Box>
    )
}
